import React from 'react';

function AddSquare(props: object) {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.62598 9.5H12.626"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.62598 12.5V6.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.37598 17H11.876C15.626 17 17.126 15.5 17.126 11.75V7.25C17.126 3.5 15.626 2 11.876 2H7.37598C3.62598 2 2.12598 3.5 2.12598 7.25V11.75C2.12598 15.5 3.62598 17 7.37598 17Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default AddSquare;
